document.addEventListener("DOMContentLoaded", function() {
    var posterModal = document.getElementById("Deferred-Poster-Modal-38685872718122");

    if (posterModal) {
        posterModal.style.display = "block";
    }
});

document.addEventListener("DOMContentLoaded", function() {
    var playButton = document.getElementById("Deferred-Poster-Modal-38685872718122");
    var template = document.getElementById("video-template");
    var deferredMedia = document.querySelector("deferred-media");

    if (playButton && template && deferredMedia) {
        playButton.addEventListener("click", function() {
            // Remove any existing video (if needed)
            var existingVideo = deferredMedia.querySelector("video");
            if (existingVideo) {
                existingVideo.remove();
            }

            // Clone the content of the template
            var videoElement = document.importNode(template.content, true);
            
            // Append the video to the deferred-media element
            deferredMedia.appendChild(videoElement);

            // Hide the play button and show the video
            playButton.style.display = "none";

            // Make sure the video and its poster are displayed correctly
            var video = deferredMedia.querySelector("video");
            if (video) {
                video.style.display = "block";
                video.play().catch(function(error) {
                    console.error("Error playing video:", error);
                });
            }

            // Ensure the poster image is set correctly
            video.setAttribute('poster', '//cellercise.com/cdn/shop/files/preview_images/5150618033754c0ca9533d460114f4e6.thumbnail.0000000000_2048x.jpg?v=1726126315');
        });
    } else {
        console.error("Play button, template, or deferred-media element not found.");
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const menRadio = document.querySelector('input[name="For"][value="Men"]');
  const womenRadio = document.querySelector('input[name="For"][value="Women"]');
  const shoeSizeOptions = document.querySelectorAll('input[name="Shoe size"]');
  const variantSelect = document.querySelector('[name="id"]'); // Shopify Variant Dropdown

  function updateShoeSizes() {
    const isMenSelected = menRadio.checked;
    const defaultSize = isMenSelected ? "9" : "6"; // Default size: 9 for Men, 6 for Women
    let selectedOption = null;

    shoeSizeOptions.forEach((option) => {
      const size = option.value;
      const label = document.querySelector(`label[for="${option.id}"]`);

      if (
        (isMenSelected && ["9", "10", "11", "12"].includes(size)) ||
        (!isMenSelected && ["6", "7", "8", "9", "10"].includes(size))
      ) {
        option.style.display = "inline-block"; // Show input
        label.style.display = "inline-block"; // Show label

        if (size === defaultSize) {
          option.checked = true;
          selectedOption = option;
        }
      } else {
        option.style.display = "none"; // Hide input
        label.style.display = "none"; // Hide label
        option.checked = false; // Uncheck hidden options
      }
    });

    if (!selectedOption) {
      const visibleOptions = Array.from(shoeSizeOptions).filter(
        (option) => option.style.display === "inline-block"
      );
      if (visibleOptions.length > 0) {
        visibleOptions[0].checked = true;
      }
    }

    // Force update Shopify variant selection
    updateShopifyVariant();
  }

  function updateShopifyVariant() {
    const selectedSize = document.querySelector('input[name="Shoe size"]:checked')?.value;
    const selectedGender = menRadio.checked ? "Men" : "Women";

    if (!selectedSize || !selectedGender) return;

    // Find the correct variant in Shopify's dropdown
    const variantOptions = Array.from(variantSelect.options);
    const matchingVariant = variantOptions.find(option => {
      return option.text.includes(selectedGender) && option.text.includes(selectedSize);
    });

    if (matchingVariant) {
      variantSelect.value = matchingVariant.value; // Select the correct variant
      variantSelect.dispatchEvent(new Event("change")); // Trigger Shopify update
    } else {
      console.error("Cannot find variant for:", selectedGender, selectedSize);
    }
  }

  // Attach event listeners
  menRadio.addEventListener("change", updateShoeSizes);
  womenRadio.addEventListener("change", updateShoeSizes);
  shoeSizeOptions.forEach(option => option.addEventListener("change", updateShopifyVariant));

  // Fix: Run on page load to ensure correct variant is selected
  updateShoeSizes();
  setTimeout(updateShopifyVariant, 200); // Ensures Shopify registers the change
});